<button [id]="buttonId" [ngClass]="buttonClass" class="ms-Button" type="button" (click)="click()">
    <span class="ms-Button-label">
        {{label}}
        <i *ngIf="icon" class="ms-Icon" [class]="icon"></i>
    </span>
</button>
